import * as ast from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateSelection(nodeFields, pifFileSummary, accept) {
    const { idField, richAssetField } = nodeFields;
    if (!richAssetField || !ast.isRichAssetSelection(richAssetField?.content))
        return;
    const selectionString = richAssetField?.content?.value?.trim() ?? '';
    // This could either be a static or dynamic selection content based on the string format
    if (selectionString.startsWith('{') && selectionString.endsWith('}')) {
        const indexOfStar = selectionString.indexOf('*');
        if (indexOfStar === -1) {
            accept('error', `The dynamic selection content is not formatted correctly. It should be in the format '{ source_node * source_var }'.`, {
                node: richAssetField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: nodeFields.nodeNumber,
                    propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                },
            });
        }
        else {
            // Split the string into it's parts. Account for start and end parenthesis
            const nodeNumber = selectionString.slice(1, indexOfStar).trim();
            const variableName = selectionString
                .slice(indexOfStar + 1, selectionString.length - 1)
                .trim();
            // The referenced node must exist
            const refNodeFields = pifFileSummary.getNodeByNodeNumber(nodeNumber);
            if (!refNodeFields) {
                accept('error', `Could not resolve reference to Node named '${nodeNumber}'.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
            else {
                // The referenced node exists. Get the required fields for the referenced node.
                const { outputField: refOutputField } = refNodeFields;
                // The variable must exist on the referenced node
                const matchingOutputVariable = refOutputField?.output?.find((o) => {
                    return o.value === variableName;
                });
                if (!matchingOutputVariable) {
                    accept('error', `The referenced variable '${variableName}' does not exist on the referenced node '${refNodeFields.nodeNumber}'.`, {
                        node: richAssetField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: nodeFields.nodeNumber,
                            propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                        },
                    });
                }
            }
        }
    }
    else {
        // For static selection string, we can have multiple selection items separated by a pipe
        const selections = selectionString.split('|');
        selections.forEach((selection) => {
            // Each individual selection has the format label~destination
            // Get the individual parts of the selection string
            const indexOfTilde = selection.indexOf('~');
            if (indexOfTilde === -1) {
                accept('error', `The static selection content is not formatted correctly. It should be in the format 'label ~ destination'.`, {
                    node: richAssetField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: nodeFields.nodeNumber,
                        propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                    },
                });
            }
            else {
                // Split the string into it's parts.
                // const label = selection.slice(0, indexOfTilde).trim();
                const nodeNumber = selection.slice(indexOfTilde + 1).trim();
                // The referenced node must exist
                const refNodeFields = pifFileSummary.getNodeByNodeNumber(nodeNumber);
                if (!refNodeFields) {
                    accept('error', `Could not resolve reference to Node named '${nodeNumber}'.`, {
                        node: richAssetField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: nodeFields.nodeNumber,
                            propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
                        },
                    });
                }
            }
        });
    }
}
//# sourceMappingURL=selection.js.map